import AddQuestionComponent from "./xmotTQSharedComponents/AddQuestionComponent";

const radioButtons = [
  { id: 1, label: "Open Ended Question", value: "open_ended_question" },
  {
    id: 2,
    label: "Multiple Choice - Single Select",
    value: "multiple_choice_single_select",
    showInfoIcon: true,
  },
  {
    id: 3,
    label: "Multiple Choice - Multi-Select",
    value: "multiple_choice_multi_select",
    showInfoIcon: true,
  },
  {
    id: 4,
    label: "Rating Question",
    value: "rating_question",
    showInfoIcon: true,
  },
  {
    id: 5,
    label: "Ranking Question",
    value: "ranking_question",
    showInfoIcon: true,
  },
];

const XmotQuestion = ({
  index,
  taskQuestion,
  updateQuestionItem,
  taskQuestions,
  handleAddQuesTask,
  answerOptionText,
  handleShuffle,
  isLocked,
  surveyType = "",
}) => {
  return (
    <div className="mt-2 mb-2">
      <AddQuestionComponent
        index={index}
        taskQuestion={taskQuestion}
        radioButtons={radioButtons}
        updateQuestionItem={updateQuestionItem}
        taskQuestions={taskQuestions}
        handleAddQuesTask={handleAddQuesTask}
        type={"parent"}
        showAddTQBtn={true}
        answerOptionText={answerOptionText}
        handleShuffle={handleShuffle}
        quesCount={index}
        isLocked={isLocked}
        surveyType={surveyType}
      />
    </div>
  );
};

export default XmotQuestion;
